import * as React from 'react';
import type { SVGProps } from 'react';
const Svg247CustomerSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M32 35h8m-8 7h14m-6 16c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18c0 2.394.468 4.68 1.316 6.769.163.4.244.6.28.762.035.158.048.275.048.437 0 .165-.03.346-.09.707l-1.186 7.116c-.124.745-.186 1.117-.07 1.387a1 1 0 0 0 .524.525c.27.115.642.053 1.387-.071l7.116-1.186c.361-.06.542-.09.707-.09.162 0 .28.013.437.048.162.036.362.117.762.28A18 18 0 0 0 40 58"
    />
  </svg>
);
export default Svg247CustomerSupport;
